import {Rating} from 'primereact/rating'
import {ReactComponent as BiSolidDislike} from '../../../assets/icons/BiSolidDislike.svg'
import {ReactComponent as BiSolidLike} from '../../../assets/icons/BiSolidLike.svg'
//#region Table
export const columnList = [
    {field: 'createdAt', header: 'Created At', initialShown: true},
    {
        field: 'comment',
        header: 'Comment',
        body: rowData => rowData?.comment || '-',
        initialShown: true,
    },
    {
        field: 'rating',
        header: 'Rating',
        body: rowData =>
            !!rowData?.rating && rowData?.rating !== 'unrated' ? (
                <Rating
                    value={
                        rowData?.rating === 'one_star'
                            ? 1
                            : rowData?.rating === 'two_stars'
                            ? 2
                            : rowData?.rating === 'three_stars'
                            ? 3
                            : rowData?.rating === 'four_stars'
                            ? 4
                            : rowData?.rating === 'five_stars'
                            ? 5
                            : 0
                    }
                    cancel={false}
                    readOnly
                />
            ) : (
                '-'
            ),
        initialShown: true,
    },
    {
        field: 'signal',
        header: 'Signal',
        body: rowData =>
            !!rowData?.signal ? (
                rowData?.signal === 'like' ? (
                    <BiSolidLike
                        style={{
                            width: '24px',
                            height: '24px',
                        }}
                    />
                ) : rowData?.signal === 'dislike' ? (
                    <BiSolidDislike
                        style={{
                            width: '24px',
                            height: '24px',
                        }}
                    />
                ) : (
                    '-'
                )
            ) : (
                '-'
            ),
        initialShown: true,
    },
]
//#endregion
